import React from "react";
import { BemHelper } from "@/utils/BemHelper";
import { THEMES } from "../constants";
import classNames from "classnames";
import { Theme } from "../types";

export type CtThemeSelectorProps = {
  value: Theme;
  onChange?: (theme: Theme) => void;
  disabledThemes?: Theme[];
};

const bem = new BemHelper("ct-theme-selector");

function CtThemeSelector({ value, onChange, disabledThemes }: CtThemeSelectorProps) {
  const activeThemes = Object.values(THEMES).filter((theme) => !disabledThemes?.includes(theme));

  return (
    <div className={bem.block()}>
      {activeThemes.map((theme: Theme) => (
        <div key={theme} className={bem.element("theme")} onClick={() => onChange?.(theme)}>
          <div
            className={classNames(bem.element("theme-boxes"), bem.modifier(theme, "theme-boxes"))}
          >
            <div
              className={classNames(bem.element("theme-box"), bem.modifier("box-1", "theme-box"))}
            />
            <div
              className={classNames(bem.element("theme-box"), bem.modifier("box-2", "theme-box"))}
            />
            <div
              className={classNames(bem.element("theme-box"), bem.modifier("box-3", "theme-box"))}
            />
          </div>
          {theme === value && <div className={bem.element("selected-label")}>Selected</div>}
        </div>
      ))}
    </div>
  );
}

CtThemeSelector.defaultProps = {
  onChange: () => {},
  disabledThemes: [],
};

export default CtThemeSelector;
